// DEPENDENCIES
//// Angular
import { createReducer, on } from "@ngrx/store";
//// Local
import { initialRuleState } from "./rule.states";
import { RuleActions } from "./rule.actions";
import { UserActions } from "../user/user.actions";


export const ruleReducer = createReducer(
    initialRuleState,

    on(RuleActions.loadRuleTemplatesSuccess, (state, { rules }) => ({
        ...state,
        templates: rules
    })),

    on(UserActions.logout, _ => ({
        ...initialRuleState
    }))
)

